import { render } from "./ObjectConfigWindow.vue?vue&type=template&id=622b0675&scoped=true&ts=true"
import script from "./ObjectConfigWindow.vue?vue&type=script&lang=ts"
export * from "./ObjectConfigWindow.vue?vue&type=script&lang=ts"

import "./ObjectConfigWindow.vue?vue&type=style&index=0&id=622b0675&scoped=true&lang=scss"

import exportComponent from "/home/appstore/appstore/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-622b0675"]])

export default __exports__